import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=373ccc9b&"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationEdit.vue?vue&type=style&index=0&id=373ccc9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports